module.exports = __webpack_public_path__ + "img/shop-by-style-filter-cjdr.dd4b2e15.png";